<template>
<div>
  <template>
    <h4 class="mt-5">Trip Options</h4>
  </template>

  <div class="dropdown">
    <button class="btn dropdown-toggle"
            type="button"
            id="dropdownMenuDepartArriveButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
      {{ selectedLabel }}
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuDepartArriveButton">
      <a v-for="(option, index) in options"
         :key="index"
         @click="changeHandler(option)"
         class="dropdown-item">
        {{ option.label }}</a>
    </div>
  </div>
  <!-- <div class="dropdown">
    <select class="form-control"
            name="select-depart-arrive"
            tabindex="0"
            title="Select leave now, depart at or arrive by"
            aria-label="Select leave now, depart at or arrive by"
            v-model="selectedValue">
      <option v-for="(option, index) in options"
              :value="option.value"
              :key="index">
        {{ option.label }}</option>
    </select>
  </div> -->

</div>
</template>

<script>

// for more details on OTP options parameter see
// http://dev.opentripplanner.org/apidoc/0.20.0/resource_PlannerResource.html

export default {
  name: 'trip-planner-options',
  props: ['isFuture'],
  data () {
    return {
      selectedValue: 'QUICK',
      selectedLabel: 'Quick',
      options: [
        { value: 'QUICK', label: 'Fastest Trip' },
        { value: 'FLAT', label: 'Flattest Route' },
        { value: 'GREENWAYS', label: 'Greenest Route' },
        { value: 'SAFE', label: 'Safest Route' },
        { value: 'TRANSFERS', label: 'Fewest Transfers' },
        // { value: 'TRIANGLE', label: 'Triangle?' }
      ]
    }
  },
  computed: {
    router () { // get router params and query
      return this.$store.getters['tripPlanner/router'];
    },
    resultsViewActive () {
      return this.$store.getters['tripPlanner/resultsViewActive']
    },
    tripOptions: {
      get () {
        return this.$store.getters['tripPlanner/inputs'].options.optimize;
      },
      set (val) {
        let tripOptionsNew = Object.assign({}, this.$store.getters['tripPlanner/inputs'].options)
        tripOptionsNew.optimize = val
        this.$store.commit('tripPlanner/SET_TRIP_OPTIONS', tripOptionsNew);
      }
    }
  },
  methods: {
    changeHandler (option) {
      // this.selectedValue = option.value
      this.tripOptions = option.value
      this.selectedLabel = option.label

      this.$router.push({
            name  : (this.$route.path.substr(0,3) === '/es') ? 'es-trip-planner-inputs-ready-plan' : 'trip-planner-inputs-ready-plan',
            params: this.router.params,
            query : this.router.query,
          });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/TripPlannerOptions.vue